export const QueryKey = {
	content: 'content',
	products: 'products',
	assets: 'assets',
	attributeGroups: 'attribute-groups',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
